import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function ExercisePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboardingV2.exercise.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-green"
          emoji="🏋️"
          label={t("pages.onboardingV2.exercise.yes")}
          name={t("pages.onboardingV2.exercise.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.exercise.yes", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-blue"
          emoji="🚶"
          label={t("pages.onboardingV2.exercise.sometimes")}
          name={t("pages.onboardingV2.exercise.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.exercise.sometimes", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-yellow"
          emoji="😴"
          label={t("pages.onboardingV2.exercise.rarely")}
          name={t("pages.onboardingV2.exercise.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.exercise.rarely", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-orange"
          emoji="🛋️"
          label={t("pages.onboardingV2.exercise.never")}
          name={t("pages.onboardingV2.exercise.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.exercise.never", {
            lng: "en",
          })}
        />
      </Form>
    </Layout>
  )
}
